import { lazy, Suspense, useCallback, useState } from 'react';
import MenuOption from '~/constants/MenuOption';
import useClientSide from '~/hooks/useClientSide';
import FilterDrawer from './FilterDrawer';
import type WithClassName from './WithClassName';
import WithExpandOnOpen from './WithExpandOnOpen';

const Budget = lazy(
  () => import(/* webpackChunkName: "BudgetFacet" */ './Budget')
);

type OwnProps = WithClassName & WithExpandOnOpen;

function PaymentAndPrice({ className, expandOnOpen }: OwnProps) {
  const isClientSide = useClientSide();
  const expandSection = expandOnOpen === MenuOption.Price;
  const [show, setShow] = useState(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-payment-price"
      facetContent={2}
      facetName="Payment & Price"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [])}
      expandOnOpen={expandSection}
    >
      <div className="px-24 py-32">
        {isClientSide ? (
          <Suspense fallback={null}>
            <Budget />
          </Suspense>
        ) : null}
      </div>
    </FilterDrawer>
  );
}

export default PaymentAndPrice;
